import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Topbar from "../components/Topbar";
import Breadcrumb from "../components/Breadcrumb";
import "../styles/ImagenesPaciente.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ModalConfirmacion from "../components/ModalConfirmacion";

export default function ImagenesPaciente() {
    const { expediente } = useParams();
    const [imagenes, setImagenes] = useState([]);
    const [archivo, setArchivo] = useState(null);
    const [paciente, setPaciente] = useState(null);
    const [seleccionada, setSeleccionada] = useState(null);
    const [imagenGrande, setImagenGrande] = useState(null);
    const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);
    const [editandoId, setEditandoId] = useState(null);
    const [nombreEditado, setNombreEditado] = useState("");
    const [zoom, setZoom] = useState(1);
    const [offset, setOffset] = useState({ x: 0, y: 0 });
    const [arrastrando, setArrastrando] = useState(false);
    const startRef = React.useRef({ x: 0, y: 0 });


    // Cargar paciente
    useEffect(() => {
        async function fetchPaciente() {
            try {
                const { data } = await axios.get(`/api/pacientes/${expediente}`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
                });
                setPaciente(data);
            } catch (err) {
                console.error("Error al cargar paciente:", err);
            }
        }
        fetchPaciente();
    }, [expediente]);

    // Cargar imágenes
    useEffect(() => {
        axios
            .get(`/api/imagenes/${expediente}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
            })
            .then(res => setImagenes(res.data))
            .catch(() => toast.error("Error al cargar imágenes"));
    }, [expediente]);

    // Subir imagen CORREGIDO
    const subirImagen = async () => {
        if (!archivo) {
            toast.error("Selecciona una imagen primero");
            return;
        }

        const formData = new FormData();
        formData.append("imagen", archivo);

        try {
            // ⚠️ IMPORTANTE: usar axios normal, no axios global ni api
            const res = await axios.post(
                `/api/imagenes/${expediente}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            setImagenes(prev => [...prev, res.data]);
            setArchivo(null);
            toast.success("Imagen subida correctamente");

        } catch (err) {
            console.error("Error al subir imagen:", err);
            toast.error("Error al subir la imagen");
        }
    };

    const guardarNombre = async (img) => {
        await axios.put(
            `/api/imagenes/${img.id}/nombre`,
            { filename: nombreEditado },
            { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
        );

        setImagenes(prev =>
            prev.map(i =>
            i.id === img.id ? { ...i, filename: nombreEditado } : i
            )
        );

        setEditandoId(null);
        setNombreEditado("");
        };

        const cancelarEdicion = () => {
        setEditandoId(null);
        setNombreEditado("");
    };

    const onWheelZoom = e => {
        e.preventDefault();
        const delta = e.deltaY < 0 ? 0.1 : -0.1;
        setZoom(z => Math.min(Math.max(z + delta, 1), 5));
    };

    const onMouseDown = e => {
        setArrastrando(true);
        startRef.current = {
            x: e.clientX - offset.x,
            y: e.clientY - offset.y
        };
    };

    const onMouseMove = e => {
        if (!arrastrando) return;
        setOffset({
            x: e.clientX - startRef.current.x,
            y: e.clientY - startRef.current.y
        });
    };

    const resetZoom = () => {
        setZoom(1);
        setOffset({ x: 0, y: 0 });
    };

    const onMouseUp = () => setArrastrando(false);

    return (
        <>
            <Topbar />
            <ToastContainer position="top-right" autoClose={3000} />

            <div className="imagenes-page">
                <Breadcrumb />
                <h2>
                    Imágenes del Paciente{" "}
                    {paciente
                        ? [paciente.nombre, paciente.primer_apellido, paciente.segundo_apellido]
                            .filter(Boolean)
                            .join(" ")
                        : expediente}
                </h2>
                <div className="subir-imagen-box">
                    <input
                        type="file"
                        accept="image/*"
                        onChange={e => setArchivo(e.target.files[0])}
                    />
                    <button onClick={subirImagen}>Subir Imagen</button>
                    <button
                        className="btn-borrar"
                        disabled={!seleccionada}
                        onClick={() => setMostrarConfirmacion(true)}
                    >
                        Borrar imagen
                    </button>
                </div>

                <div className="galeria">
                    {imagenes.map(img => (
                        <div
                        key={img.id}
                        className={`imagen-item ${seleccionada === img.id ? "seleccionada" : ""}`}
                        onClick={() => setSeleccionada(img.id)}
                        >
                        <img
                            src={img.url}
                            alt={img.filename}
                            onDoubleClick={() => setImagenGrande(img)}
                        />

                        {/* Nombre */}
                        {editandoId === img.id ? (
                            <div className="editar-nombre">
                            <input
                                value={nombreEditado}
                                onChange={e => setNombreEditado(e.target.value)}
                            />
                            <button onClick={() => guardarNombre(img)}>
                                Guardar
                            </button>
                            <button onClick={cancelarEdicion}>
                                Cancelar
                            </button>
                            </div>
                        ) : (
                            <div
                            className="nombre-img"
                            onDoubleClick={() => {
                                setEditandoId(img.id);
                                setNombreEditado(img.filename);
                            }}
                            >
                            {img.filename}
                            </div>
                        )}
                        </div>
                    ))}
                </div>

            </div>
            <ModalConfirmacion
            abierto={mostrarConfirmacion}
            mensaje="¿Seguro que quieres borrar la imagen seleccionada?"
            onConfirmar={async () => {
                await axios.delete(`/api/imagenes/${seleccionada}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
                });

                setImagenes(prev => prev.filter(i => i.id !== seleccionada));
                setSeleccionada(null);
                setMostrarConfirmacion(false);
                toast.success("Imagen eliminada");
            }}
            onCancelar={() => setMostrarConfirmacion(false)}
            />
            {imagenGrande && (
                <div
                    className="modal-imagen"
                    onWheel={onWheelZoom}
                    onMouseMove={onMouseMove}
                    onMouseUp={onMouseUp}
                    onMouseLeave={onMouseUp}
                    onClick={() => setImagenGrande(null)}
                >
                    <img
                        src={imagenGrande.url}
                        alt={imagenGrande.filename}
                        className="imagen-grande"
                        style={{
                            transform: `translate(${offset.x}px, ${offset.y}px) scale(${zoom})`
                        }}
                        onMouseDown={onMouseDown}
                        onDoubleClick={e => {
                            e.stopPropagation();
                            resetZoom();
                        }}
                        onClick={e => e.stopPropagation()}
                        draggable={false}
                    />
                </div>
            )}
        </>
    );
}
